import React, {useEffect, useState} from "react";

import {getPresignedUrl} from "../../utils/helpers";

import styles from "./DocumentDetails.module.css";
import Analysis from "./Analysis";

const DocumentDetails = (props) => {
  const [analysis, setAnalysis] = useState([]);
  const [pdf, setPdf] = useState([]);

  const processPresignedUrl = async () => {
    const response = await getPresignedUrl(
      props.selectedDocument.document_filename
    );
    if (response.status === 200) {
      setPdf(response.result);
    }
  };

  useEffect(() => {
    const analysisArr = [];
    if (props.selectedDocument?.document_analysis) {
      for (const key of Object.keys(props.selectedDocument.document_analysis)) {
        if (Array.isArray(props.selectedDocument?.document_analysis[key])) {
          let count = 0;
          for (const item of props.selectedDocument?.document_analysis[key]) {
            analysisArr.push({
              key: `${key}_${++count}`,
              value: item.value,
              confidence: item.confidence,
              page: item.page,
              order: item.order,
            });
          }
        } else {
          const value = props.selectedDocument.document_analysis[key];
          analysisArr.push({
            key,
            value: value.value,
            confidence: value.confidence,
            page: value.page,
            order: value.order,
          });
        }
      }

      analysisArr.sort((a, b) => a.order - b.order);
      setAnalysis(analysisArr);
    }
    processPresignedUrl();
  }, [props.selectedDocument]);

  return (
    <div className={`${styles.DocumentDetails__Container}`}>
      <div className={`${styles.DocumentDetails__Document}`}>
        {pdf && (
          <object
            data={`${pdf}`}
            type="application/pdf"
            width="100%"
            height="100%"
          ></object>
        )}
        {!pdf && <h6>No document to show</h6>}
      </div>
      <div className={`${styles.DocumentDetails__Analysis}`}>
        {analysis.length > 0 &&
          analysis.map((item, index) => <Analysis item={item} />)}
      </div>
    </div>
  );
};

export default DocumentDetails;
